import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { notifyAppNavigation } from '../lib/appUpdate';

/**
 * Seitenwechsel ist der beste Moment für ein wartendes Update: Die verlassene Seite ist weg, auf
 * der neuen hat noch niemand etwas eingegeben. Nur der Pfad zählt — Filter in der Query sind kein
 * Seitenwechsel.
 */
export function AppUpdateOnNavigation() {
  const { pathname } = useLocation();
  const previous = useRef(pathname);

  useEffect(() => {
    if (previous.current === pathname) return;
    previous.current = pathname;
    notifyAppNavigation();
  }, [pathname]);

  return null;
}
